import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "#262626",
	viewBox: "0 0 22 20",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11 3.125v10m-3.75-3.75 3.75 3.75 3.75-3.75m5.626 3.75v1.25a2.5 2.5 0 0 1-2.5 2.5H4.126a2.5 2.5 0 0 1-2.5-2.5v-1.25",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20stroke%3D%22%23262626%22%20viewBox%3D%220%200%2022%2020%22%3E%3Cpath%20d%3D%22M11%203.125v10m-3.75-3.75%203.75%203.75%203.75-3.75m5.626%203.75v1.25a2.5%202.5%200%200%201-2.5%202.5H4.126a2.5%202.5%200%200%201-2.5-2.5v-1.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E%0A";
